import s from './SideImage.module.scss'
import LazyImage from '@/components/Common/LazyImage'
import LazyVideo from '@/components/Common/LazyVideo'

type Props = { data: any; priority?: boolean }

export default function SideImage({ data, priority = false }: Props) {
  return (
    <>
      <div className={`${s.space} ${s[data.side]}`}></div>
      <div className={`${s.sideImage} ${s[data.side]}`}>
        <div className={`${s.imageWrapper}`}>
          {data.videoUrl ? (
            <LazyVideo
              src={data.videoUrl}
              thumbnail={data.thumbnail}
              autoplay={true}
              muted={true}
              allowAudio={data.allowAudio}
              fullHeight
            />
          ) : (
            <LazyImage
              src={data.thumbnail?.imageUrl}
              alt={data.thumbnail?.filename}
              width={data.thumbnail?.metadata.dimensions.width || 800}
              height={data.thumbnail?.metadata.dimensions.height || 600}
              priority={priority}
            />
          )}
        </div>
      </div>
    </>
  )
}
